module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper",
    class: {
      'page-short': !_vm.defaultPage
    }
  }, [_c('dialog'), _vm._v(" "), _c('tooltip'), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "brand-container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.getHomeName()
      }
    }
  }, [_c('div', {
    staticClass: "logo-img"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper section-nav"
  }, [_c('div', {
    staticClass: "none-space"
  }), _vm._v(" "), _c('i18n'), _vm._v(" "), _c('support'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "menu-wrapper"
  }, _vm._l((_vm.getMenu()), function(item) {
    return _c('li', [_c('router-link', {
      directives: [{
        name: "popover",
        rawName: "v-popover:tooltip.right",
        value: (_vm.t(item.title)),
        expression: "t(item.title)",
        arg: "tooltip",
        modifiers: {
          "right": true
        }
      }],
      class: item.type,
      attrs: {
        "to": {
          name: item.name
        },
        "exact": ""
      }
    }, [(item.iconClass) ? _c('span', {
      class: item.iconClass
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pd"
    }, [_vm._v(" " + _vm._s(_vm.t(item.label)))])])], 1)
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "bottom": "0",
      "padding-left": "5px"
    }
  }, [_c('a', {
    staticClass: "ico ico-toggle-right",
    class: {
      'ico-toggle-left': _vm.defaultPage
    },
    attrs: {
      "href": "#",
      "id": "toggle-menu"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v(" ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-column"
  }, [(_vm.isLogged) ? _c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-left"
  }, [(_vm.projectMetadata.showAppointmentButton) ? _c('li', [_c('div', [_c('button', {
    staticClass: "btn navbar-button"
  }, [_c('a', {
    attrs: {
      "href": _vm.projectMetadata.appointmentLink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon icon-meeting navbar-button-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-button-text"
  }, [_vm._v(_vm._s(_vm.t('Make an appointment')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.projectMetadata.showTutorialButton) ? _c('li', [_c('div', [_c('button', {
    staticClass: "btn navbar-button",
    on: {
      "click": _vm.showTutorialModal
    }
  }, [_c('span', {
    staticClass: "icon icon-video-player navbar-button-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-button-text"
  }, [_vm._v(_vm._s(_vm.t('Watch the tutorial video')))])])])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._l((_vm.getUserMenu()), function(item) {
    return _c('li', [_c('router-link', {
      directives: [{
        name: "popover",
        rawName: "v-popover:tooltip",
        value: (_vm.t(item.label)),
        expression: "t(item.label)",
        arg: "tooltip"
      }],
      attrs: {
        "to": {
          name: item.name
        },
        "exact": ""
      }
    }, [(item.iconClass) ? _c('span', {
      class: item.iconClass
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pd"
    }, [_vm._v(" " + _vm._s(_vm.t(item.label)))])])], 1)
  }), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.getUserName()) + " " + _vm._s(_vm.getExpiredDays()) + "\n                    ")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "ico ico-info",
    class: {
      'notify': _vm.newNotifications
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.openNotifications()
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newNotifications),
      expression: "newNotifications"
    }]
  }), _vm._v(" ")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t('Logout')),
      expression: "t('Logout')",
      arg: "tooltip"
    }],
    staticClass: "ico ico-off",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(" ")])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('v-dialog'), _vm._v(" "), _c('vue-confirm-dialog'), _vm._v(" "), _c('div', {
    staticClass: "primary-content"
  }, [_c('router-view', {
    key: _vm.$route.path
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationsPanelOpened),
      expression: "notificationsPanelOpened"
    }],
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Notifications')) + " "), _c('a', {
    staticClass: "ico ico-close close",
    on: {
      "click": function($event) {
        return _vm.closeNotifications()
      }
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('notification-panel', {
    attrs: {
      "existsNew": _vm.newNotifications,
      "opened": _vm.notificationsPanelOpened
    }
  })], 1), _vm._v(" "), _c('ModalFactory')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9616dd12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Dashboard.vue
// module id = 1339
// module chunks = 2